import {Map, fromJS, List} from "immutable";

import {DOWNLOAD_CONTENT_REQUEST, DOWNLOAD_CONTENT_SUCCESS, DOWNLOAD_CONTENT_ERROR} from "./content-actions"

const content = (state = Map({
    payload: List([]),
    contentId: "",
    contentType: "",
    isFetching: false,
    error: false
}), action) => {
    let newState;
    switch (action.type) {

        // Requests
        case DOWNLOAD_CONTENT_REQUEST:
            newState = state.merge({
                isFetching: true,
                contentId: action.contentId,
                contentType: action.contentType,
                error: false
            });
            return newState;

        // Success
        case DOWNLOAD_CONTENT_SUCCESS:
            newState = state.merge({
                payload: fromJS(action.payload),
                isFetching: false,
                contentId: "",
                contentType: "",
                error: false
            });
            return newState;

        // Errors
        case DOWNLOAD_CONTENT_ERROR:
            newState = state.merge({
                isFetching: false,
                contentId: "",
                contentType: "",
                error: action.error,
                errorMessage: action.errorMessage
            });
            return newState;
        default:
            return state;
    }
};

export default content;